/** @jsx jsx */
import { jsx } from 'theme-ui'
import { useAuth } from '../../../utils/useAuth'
import { isStringValid } from '../../../utils/globalHelper'
import { string } from 'prop-types'
import Heading from '../Heading'

const HelloTitle = ({ headline, subtitle }) => {
  const { user } = useAuth()
  const hideName = user?.hideName
  const preferredName = user
    ? isStringValid(user.preferredName)
      ? user.preferredName + '!'
      : ''
    : ''
  const firstName = user
    ? isStringValid(user.firstName)
      ? user.firstName + '!'
      : ''
    : ''
  const displayName = hideName
    ? ' !'
    : isStringValid(preferredName)
    ? ', ' + preferredName
    : ', ' + firstName
  const finalHeadline = 'Hello' + displayName + ' ' + headline
  return <Heading headline={finalHeadline} subtitle={subtitle} />
}
HelloTitle.propTypes = {
  headline: string.isRequired,
  subtitle: string,
}
export default HelloTitle
